// ── 사용자 표시 라벨 공용 유틸 ──────────────────────────────────
// 2026-08 요청: 최고관리자(ninegro, role==='superadmin')로 로그인한 경우, 사이드바뿐 아니라
// 각 메뉴의 "출력자"(인쇄/내보내기 시 하단에 찍히는 담당자 표기)에도 부서/직급/이름 대신
// "최고관리자"로 표시한다. App.js Sidebar()에 먼저 적용했던 규칙과 동일한 기준(role만
// 확인, 부여받은 관리자(admin)는 대상 아님)을 여러 페이지에서 재사용하기 위한 공용 함수.
//
// 사용 예:
//   const printedBy = printedByLabel(user); // "부서 직급 이름" 또는 "최고관리자"
//   const printedBy = printedByLabel(user, { withDept: false }); // 부서 없이 "직급 이름"

export function printedByLabel(u, { withDept = true } = {}) {
  if (!u) return '-';
  if (u.role === 'superadmin') return '최고관리자';
  const parts = withDept ? [u.department, u.position, u.name] : [u.position, u.name];
  const joined = parts.filter(Boolean).join(' ');
  return joined || '-';
}

export default printedByLabel;
